import axios from 'axios'

export default {
    //Listado de supervisores
    get: () => axios.get('managers'),
    store: (data) => axios.post('managers/store', data),
    update: (data) => axios.post('managers/update', data),
    downgrade: (data) => axios.post('managers/downgrade', data),
    upgrade: (data) => axios.post('managers/upgrade', data),
    delete: (id) => axios.post('managers/delete', id),
    import: (data) => axios.post('managers/import', data),
    
    generateLink: (data) => axios.post('managers/generate-link', data),
    getByChallenge: (challenge_id) => axios.get('challenges/'+challenge_id+'/managers'),

    // Puntos supervisores
    getRedeemablePoints: () => axios.get('managers/redeemable-points'),
    getRedeemablePointsHistory: (id) => axios.get('managers/redeemable-points-history/'+id),
    getExcelRedeemablePoints: () => axios.get('managers/redeemable-points-excel'),
    deleteRedeemablePoint: (id) => axios.post('managers/delete-redeemable-points', id),
    getPointTickets: (type) => axios.post('managers/point-tickets', {type: type}),
    getPointProducts: (type) => axios.post('managers/point-products', {type: type}),

    // Puntos supervisores - Canje aprobados
    getRedeemablePointsApprovedByManager: (data) => axios.post('managers/redeemable-points-approved-by-manager', data),
    boughtAward: (data) => axios.post('managers/awards/bought', data),

    // Puntos supervisores - Canje rechazados
    updatePoints: (data) => axios.post('managers/update-points', data),
    getAwardExchangesHistory: () => axios.get('managers/awards/exchanges-history'),
}